// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2hx3F","header":"PatientQuestionnaire_header__2c2_N","info":"PatientQuestionnaire_info__17yz6"};